export type HeroTone = 'onLight' | 'onDark';

// Smoked-glass surfaces for the hero action buttons. onDark is a white frosted
// pill (for dark headers); onLight is a dark-tint pill (for light heros). Both
// pair with dark text.
const SURFACES: Record<HeroTone, string> = {
  onLight:
    'bg-[rgba(0,0,0,0.10)] border border-[rgba(255,255,255,0.15)] backdrop-blur-sm hover:bg-[rgba(0,0,0,0.2)]',
  onDark:
    'bg-[rgba(255,255,255,0.75)] border border-[rgba(255,255,255,0.4)] backdrop-blur-sm hover:bg-[rgba(255,255,255,0.9)]',
};

export function glassSurface(tone: HeroTone): string {
  return SURFACES[tone];
}
